<template>
    <div class="tooltip" v-tippy="tippyOptions">
        <div class="icon">
            <QuestionIcon />
        </div>
    </div>
</template>
<script>
import { Tippy } from 'vue-tippy'
import QuestionIcon from './IconComponents/questionIcon.vue'
export default {
    name: "Tooltip",
    components: {
        Tippy,
        QuestionIcon
    },
    props: {
        text: {
            type: String,
            required: true
        },
        fontSize: {
            type: String,
            default: '26px'
        },
        maxWidth: {
            type: String,
            default: '300px'
        }
    },
    computed: {
        tippyOptions() {
            return {
                content: this.text,
                theme: 'custom-tooltip',
                placement: 'top',
                arrow: true,
                duration: [200, 150],
                maxWidth: this.maxWidth,
                allowHTML: true,
                onCreate(instance) {
                    // Appliquer les styles personnalisés au tooltip
                    const tooltip = instance.popper.querySelector('.tippy-box');
                    if (tooltip) {
                        tooltip.style.fontSize = this.fontSize;
                        tooltip.style.lineHeight = '1.4';
                        tooltip.style.padding = '8px 12px';
                    }
                }
            };
        }
    }
}
</script>

<style scoped>
.tooltip {
    display: inline-block;
    cursor: help;
}

.icon {
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Styles globaux pour le thème custom-tooltip */
:global(.tippy-box[data-theme~='custom-tooltip']) {
    background-color: #1f2937;
    color: white;
    border-radius: 6px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

:global(.tippy-box[data-theme~='custom-tooltip'] .tippy-arrow) {
    color: #1f2937;
}

:global(.tippy-box[data-theme~='custom-tooltip'] .tippy-content) {
    font-weight: 400;
    text-align: center;
}
</style>